/**
 * @file Add Location Page — /mi-perfil/ubicacion
 */
import React, { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { ArrowLeft, Plus, MapPin, Video } from "lucide-react";
import { useProfessionalLocations } from "../hooks/useProfessionalLocations";
import { Button, Card, Input, Switch, toast } from "../ui";
import "./AddLocation.css";

export default function AddLocation() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { addLocation } = useProfessionalLocations();

  const [locType, setLocType] = useState(
    searchParams.get("virtual") === "1" ? "virtual" : "presencial"
  );
  const [form, setForm] = useState({
    name: "",
    address: "",
    colonia: "",
    city: "",
    state: "",
    isMain: false,
  });
  const [submitting, setSubmitting] = useState(false);

  const isVirtual = locType === "virtual";

  const handleSave = async () => {
    if (!isVirtual && !form.address.trim()) {
      toast.error("La dirección es obligatoria");
      return;
    }
    try {
      setSubmitting(true);
      await addLocation({
        isVirtual,
        name: isVirtual ? form.name || "Teleconsulta" : form.name || null,
        address: isVirtual ? null : form.address || null,
        colonia: isVirtual ? null : form.colonia || null,
        city: isVirtual ? null : form.city || null,
        state: isVirtual ? null : form.state || null,
        isMain: form.isMain,
      });
      toast.success("Ubicación agregada");
      navigate("/mi-perfil");
    } catch (err) {
      toast.error(
        err?.response?.data?.message ||
          "Has alcanzado el límite de ubicaciones de tu plan. Actualiza a Pro para agregar más."
      );
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="al-page">
      <Button variant="ghost" leftIcon={<ArrowLeft size={14} />} onClick={() => navigate("/mi-perfil")}>
        Volver a Mi Perfil
      </Button>

      <header>
        <h1 className="al-title">Agregar ubicación</h1>
      </header>

      <Card>
        <div className="al-form">
          <div className="al-toggle">
            <button
              type="button"
              className={`al-toggle-btn ${locType === "presencial" ? "al-toggle-on" : ""}`}
              onClick={() => setLocType("presencial")}
            >
              <MapPin size={14} /> Presencial
            </button>
            <button
              type="button"
              className={`al-toggle-btn ${locType === "virtual" ? "al-toggle-on" : ""}`}
              onClick={() => setLocType("virtual")}
            >
              <Video size={14} /> Teleconsulta
            </button>
          </div>

          {isVirtual ? (
            <Input
              label="Nombre (opcional)"
              placeholder="Ej: Videollamada / Zoom"
              value={form.name}
              onChange={(e) => setForm({ ...form, name: e.target.value })}
              hint="Por defecto se mostrará como «Teleconsulta»"
            />
          ) : (
            <>
              <Input
                label="Nombre del consultorio (opcional)"
                placeholder="Ej: Consultorio principal"
                value={form.name}
                onChange={(e) => setForm({ ...form, name: e.target.value })}
              />
              <Input
                label="Calle y número *"
                placeholder="Ej: Av. Hidalgo 123"
                value={form.address}
                onChange={(e) => setForm({ ...form, address: e.target.value })}
              />
              <Input
                label="Colonia"
                placeholder="Ej: Centro"
                value={form.colonia}
                onChange={(e) => setForm({ ...form, colonia: e.target.value })}
              />
              <div className="al-row">
                <Input
                  label="Ciudad"
                  value={form.city}
                  onChange={(e) => setForm({ ...form, city: e.target.value })}
                />
                <Input
                  label="Estado"
                  value={form.state}
                  onChange={(e) => setForm({ ...form, state: e.target.value })}
                />
              </div>
            </>
          )}

          <Switch
            label="Ubicación principal"
            checked={form.isMain}
            onCheckedChange={(c) => setForm({ ...form, isMain: !!c })}
          />

          <Button
            size="lg"
            fullWidth
            leftIcon={<Plus size={14} />}
            onClick={handleSave}
            loading={submitting}
          >
            Guardar ubicación
          </Button>
        </div>
      </Card>
    </div>
  );
}
